import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { MpxProviderId, MpxProviderStaticData } from '~/tenants/mpx/model/MpxProvider';

export enum MpxLocation {
  DALLAS = 'DFW',
  ELPASO = 'ELP',
}

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone, addresses and pay live in ./providers.server.ts and are
 * merged into these same objects on the server (tenants/providers.server.ts).
 */
const MPX_PROVIDER_DATA_PUBLIC: Record<MpxProviderId, ProviderPublic<MpxProviderStaticData & ProviderStaticConfig>> = {
  [MpxProviderId.EMILY_VILLAGRANA]: {
    first: 'Emily',
    last: 'Villagrana',
    equipment_mppro2: true,
    equipment_mppro3: true,
    color: '#FF0000',
    headshot: 'avatar.jpg',
    location: MpxLocation.DALLAS,
  },
  [MpxProviderId.MICHAEL_SCHULTE]: {
    first: 'Michael',
    last: 'Schulte',
    equipment_mppro2: true,
    equipment_mppro3: true,
    headshot: 'avatar.jpg',
    color: '#00FF00',
    location: MpxLocation.DALLAS,
  },
  [MpxProviderId.CHRISTOPHER_COOK]: {
    first: 'Christopher',
    last: 'Cook',
    equipment_mppro2: true,
    headshot: 'avatar.jpg',
    color: '#0000FF',
    location: MpxLocation.DALLAS,
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const MPX_PROVIDER_DATA = MPX_PROVIDER_DATA_PUBLIC as Record<MpxProviderId, MpxProviderStaticData & ProviderStaticConfig>;
